import Icon from "../icons/icon";
import { COLORS, MEDIA } from "@theme";
import { MasterDataTitleStyles } from "../master-data-view/MasterDataTitleStyles";
import { Grid, Typography, Button, IconButton, Theme, useMediaQuery, Divider } from "@mui/material";

export const AdminTitle = (props: {
  name: string;
  icon: JSX.Element;
  buttonText?: string;
  onAddButton?: () => void;
  showButton?: boolean;
}) => {
  const styles = MasterDataTitleStyles();
  const { name, icon, buttonText, onAddButton, showButton } = props;
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.up(MEDIA.xsmall), { noSsr: true });

  return (
    <>
      <Grid item display="flex" flexDirection="row" justifyContent="space-between" md={12}>
        <Grid item id="admin-title-container" className="main-view-title">
          {icon}
          <Typography id="admin-title" ml="1rem">
            {name}
          </Typography>
        </Grid>
        {showButton &&
          (matches ? (
            <Button
              startIcon={<Icon icon="plus" color={COLORS.white} />}
              variant="primary"
              onClick={onAddButton}
              id="admin-create-button">
              {buttonText}
            </Button>
          ) : (
            <IconButton sx={styles.add_icon_button} onClick={onAddButton} id="admin-create-icon-button">
              <Icon icon="plus" color={COLORS.white} />
            </IconButton>
          ))}
      </Grid>
      <Divider sx={styles.divider} />
    </>
  );
};
